import TableCheckboxEditable from './TableCheckboxEditable'
export default TableCheckboxEditable